// @flow

import React from 'react';
import { withTheme } from 'styled-components';

// we cannot change the fact withTheme gives us:
// type $npm$styledComponents$Theme = {[key: string]: mixed}
// sad panda

type Props = {
  stop: number,
  id: string,
  theme: any,
};

const Star = ({ stop, id, ...props }: Props) => {
  const { theme } = props;
  const stopPercentage = Math.round(stop * 10) * 10;

  return (
    <svg viewBox="0 0 34 34" xmlns="http://www.w3.org/2000/svg">
      <defs>
        <linearGradient id={`Gradient${id}`} x1="0" x2="1" y1="0" y2="0">
          <stop offset={`${stopPercentage}%`} stopColor={theme.review.starColor} />
          <stop offset={`${stopPercentage}%`} stopColor="white" />
          <stop offset="100%" stopColor="white" />
        </linearGradient>
        <filter id="dropshadow">
          <feGaussianBlur in="SourceAlpha" stdDeviation="1" />
          <feOffset dx="0" dy="1" result="offsetblur" />
          <feComponentTransfer>
            <feFuncA type="linear" slope="0.2" />
          </feComponentTransfer>
          <feMerge>
            <feMergeNode />
            <feMergeNode in="SourceGraphic" />
          </feMerge>
        </filter>
      </defs>
      <g transform="translate(1.000000, 1.000000)">
        <path
          d="M11.0700016,9.85632792 L16.0007088,0 L20.9287129,9.85633893 L32,11.4428761 L23.9863496,19.1489417 L25.8736477,30 L16.0003722,24.8791718 L6.12497387,29.9996941 L8.01222901,19.1488829 L0,11.4428757 L11.0700016,9.85632792 Z M16.0001732,4.88199047 L12.5071483,11.8644372 L4.74926417,12.9762938 L10.3616872,18.3742137 L9.03075745,26.0264215 L16.0005097,22.4125143 L22.9677577,26.0261156 L21.6368708,18.3741549 L27.2501861,12.9762935 L19.4912739,11.8644261 L16.0001732,4.88199047 Z"
          fill="#ffffff"
          style={{ filter: 'url(#dropshadow)' }}
        />
        <polygon
          fill={`url(#Gradient${id})`}
          points="12.3600614 11.4730547 4.10545218 12.6706076 10.0788355 18.4861355 8.66790393 26.6977825 16.0532332 22.8214393 23.4365339 26.6977825 22.0256023 18.4861355 28 12.6706076 19.7443764 11.4730547 16.0532332 4"
        />
      </g>
    </svg>
  );
};

export default withTheme(Star);
